import { render, staticRenderFns } from "./TgMobile.vue?vue&type=template&id=293a0c0b"
import script from "./TgMobile.vue?vue&type=script&lang=js"
export * from "./TgMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports